import React from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';
import { CgSearch } from 'react-icons/cg';

export default connectSearchBox(
  ({ refine, currentRefinement, className, onFocus }) => (
    <form className={className}>
      <input
        className="border-0 text-lg rounded-md cursor-text -ml-1 pl-1 outline-none"
        type="text"
        placeholder="Search"
        aria-label="Search"
        onChange={(e) => refine(e.target.value)}
        value={currentRefinement}
        onFocus={onFocus}
        autoFocus={true}
      />
      <CgSearch className="w-4 m-2" />
    </form>
  )
);
